import admin from "../data/nav/admin.json";
import cmp_admin from "../data/nav/cmp_admin.json";

import counsellor from "../data/nav/counsellor.json";
import receptionist from "../data/nav/receptionist.json";
import student from "../data/nav/student.json";
import system_admin from "../data/nav/system_admin.json";
import hr from "../data/nav/hr.json";
import md from "../data/nav/md.json"
import principal from "../data/nav/principal.json"
import admission_manager from "../data/nav/admission_manager.json"
import _1syniza_md from "../data/nav/_1syniza_md.json"
import _2syniza_principal from "../data/nav/_2syniza_principal.json"
import _3syniza_program_coordinator from "../data/nav/_3syniza_program_coordinator.json"
import _4syniza_hod from "../data/nav/_4syniza_hod.json"
import _5syniza_iqac_coordinator from "../data/nav/_5iqac_coordinator.json"
import _6syniza_hr from "../data/nav/_6syniza_hr.json"
import authService from "./authService";

function setHeaderTitle(key, title) {
  localStorage.setItem(key, title)
}

export function getHeaderTitle(key) {
  return localStorage.getItem(key);
}

export function getNavItems(roleName = "new") {
  const role = authService.getCurrentRole();
  switch (role.toLowerCase()) {

    case "md":
      setHeaderTitle(role, "MD")
      return _1syniza_md;
    case "principal":
      setHeaderTitle(role, "Principal")
      return _2syniza_principal;
    case "program_coordinator":
      setHeaderTitle(role, "Program Coordinator")
      return _3syniza_program_coordinator;
    case "hod":
      setHeaderTitle(role, "HoD")
      return _4syniza_hod;
    case "iqac_coordinator":
      setHeaderTitle(role, "IQAC");
      return _5syniza_iqac_coordinator;
    case "hr":
      setHeaderTitle(role, "Human Resources");
      return _6syniza_hr;
    case "admission_manager":
      setHeaderTitle(role, "Admission Manager")
      return admission_manager;
    case "admin":
      return admin;
    case "system_admin":
      setHeaderTitle(role, "System Admins")
      return system_admin;
    case "student":
      return student;
    case "enquirer":
      setHeaderTitle(role, "Student")
      return student;
    case "counsellor":
      setHeaderTitle(role, "Counsellor")
      return counsellor;
    case "receptionist":
      return receptionist;
    case "cmp_admin":
      setHeaderTitle(role, "CMP Admin")

      return cmp_admin;
    default:
      alert("Navigation for the role: " + role + " is not configured yet");
  }
}
